import { PageMeta } from '../marketplace/shared/PageMeta';

export function TermsPage() {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <PageMeta title="Terms of Service" description="Terms of Service for the Second Chance Seed Network" path="/marketplace/terms" />

      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
      <p className="text-sm text-spi-slate mb-8">Last updated: February 2026</p>

      <div className="prose prose-sm max-w-none space-y-6 text-spi-charcoal">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Platform Usage</h2>
          <p>
            The Second Chance Seed Network ("Platform") is operated by Bay Crew Tech, LLC. By accessing or using the Platform, you agree to be bound by these Terms of Service. The Platform connects seed donors with verified recipients for charitable seed donations.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. User Responsibilities</h2>
          <p>
            Users must provide accurate and truthful information during registration. You are responsible for maintaining the confidentiality of your account credentials. You agree not to use the Platform for any unlawful purpose or in violation of these Terms.
          </p>
          <p>
            Donors are responsible for ensuring the quality and viability of donated seeds. Recipients are responsible for providing accurate project information and using received seeds for their stated purposes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Media Usage Rights</h2>
          <p>
            By uploading images, documents, or other content to the Platform, you grant Seed Programs International (SPI) and Bay Crew Tech, LLC a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and distribute such content for corporate communications, marketing, promotional purposes, and public communications. This includes use on websites, social media, print materials, and presentations.
          </p>
          <p>
            You represent and warrant that you have all necessary rights to grant this license for any content you upload.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Donations and Tax Documentation</h2>
          <p>
            The Platform facilitates the generation of IRS Form 8283 for qualifying charitable seed donations. Bay Crew Tech, LLC and SPI do not provide tax advice. Donors are responsible for consulting with their own tax advisors regarding the deductibility of donations. The Platform provides documentation tools as a convenience and makes no guarantees regarding tax outcomes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Account Verification</h2>
          <p>
            All accounts are subject to review and approval by the Platform administrators. We reserve the right to reject, suspend, or terminate any account at our sole discretion. Users may be required to provide additional documentation to verify their identity or organizational status.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Limitation of Liability</h2>
          <p>
            The Platform is provided "as is" without warranties of any kind. Bay Crew Tech, LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Platform. Our total liability shall not exceed the amount paid by you, if any, for accessing the Platform.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Bay Crew Tech, LLC, SPI, and their respective officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from your use of the Platform or violation of these Terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the United States. Any disputes arising under these Terms shall be resolved in the courts of competent jurisdiction.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">9. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. Continued use of the Platform after changes constitutes acceptance of the modified Terms. We will make reasonable efforts to notify users of significant changes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">10. Contact</h2>
          <p>
            For questions about these Terms, please contact us at support@baycrewtech.com.
          </p>
        </section>
      </div>
    </div>
  );
}
